import React from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as DialogsIcon } from 'assets/icons/meplusyou/dialogs.svg';
import { ReactComponent as DialogsActiveIcon } from 'assets/icons/meplusyou/dialogs-active.svg';
import { ReactComponent as FinderIcon } from 'assets/icons/meplusyou/finder.svg';
import { ReactComponent as MyProfileIcon } from 'assets/icons/meplusyou/myprofile.svg';
import { ReactComponent as NotificationsIcon } from 'assets/icons/meplusyou/notifications.svg';
import { ReactComponent as NotificationsActiveIcon } from 'assets/icons/meplusyou/notifications-active.svg';

import css from './meplusyouBottomNavigationBar.module.sass';

interface Props {
  isHasNewDialogs: boolean;
  isHasNewNotifications: boolean;
}

export const MeplusyouBottomNavigationBar: React.FC<Props> = ({
  isHasNewDialogs,
  isHasNewNotifications,
}) => {
  return (
    <nav className={css.root}>
      <ul className={css.list}>
        <li className={css.item}>
          <NavLink
            to="/finder"
            exact
            className={css.link}
            activeClassName={css.linkStateActive}
          >
            <FinderIcon className={css.icon} />
          </NavLink>
        </li>
        <li className={css.item}>
          <NavLink
            to="/notifications"
            exact
            className={css.link}
            activeClassName={css.linkStateActive}
          >
            {isHasNewNotifications ? (
              <NotificationsActiveIcon className={css.icon} />
            ) : (
              <NotificationsIcon className={css.icon} />
            )}
          </NavLink>
        </li>
        <li className={css.item}>
          <NavLink
            to="/threads"
            exact
            className={css.link}
            activeClassName={css.linkStateActive}
          >
            {isHasNewDialogs ? (
              <DialogsActiveIcon
                className={css.icon}
                width="26px"
                height="26px"
              />
            ) : (
              <DialogsIcon className={css.icon} width="26px" height="26px" />
            )}
          </NavLink>
        </li>
        <li className={css.item}>
          <NavLink
            to="/myprofile"
            exact
            className={css.link}
            activeClassName={css.linkStateActive}
          >
            <MyProfileIcon className={css.icon} />
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};
